import React from 'react'
import { Chart } from "react-google-charts";
import {shadeDefault} from '../InsightsColors';

const InsightSankeyGraphView =(props)=>{
    const {viewData, activeOption} = props;

    const currentOption = activeOption;// || viewData.DefaultOption;
    
    
    if(viewData && viewData.ViewData[currentOption] && viewData.ViewData[currentOption].ChartData)
    {
        // console.log("layout response view sankey", viewData.ViewData[currentOption].ChartData);
        const rawData = viewData.ViewData[currentOption].ChartData;
        const threshold = viewData.ViewOptions?.thresholdValue || 0.5;
        const chartData = [
        rawData[0], // header
        ...rawData.slice(1).filter(row => row[2] >= threshold)
        ];

        //console.log("layout response view", viewData.ViewData[currentOption].ChartData);
        //  const chartEvents = onSelect ? [
        //     {
        //         eventName: "select",
        //         callback: ({ chartWrapper }) => {
        //             console.log("chartWrapper", chartWrapper);
        //             const chart = chartWrapper.getChart();
        //             const selection = chart.getSelection();
        //             if (selection.length > 0) {
        //                 const sel = selection[0];
        //                 // Sankey selection can be a node or a link
        //                 if (sel.row !== null && sel.row !== undefined) {
        //                     // For Sankey, row refers to the link (flow) between nodes
        //                     const dataRow = chartData[sel.row + 1]; // +1 for header
        //                     const fromNode = dataRow[0];
        //                     const toNode = dataRow[1];
        //                     const value = dataRow[2];
        //                     onSelect({ type: "link", fromNode, toNode, value, dataRow });
        //                 } else if (sel.column !== null && sel.column !== undefined) {
        //                     // Sometimes column refers to a node (rare in Sankey)
        //                     const nodeName = chartData[0][sel.column];
        //                     onSelect({ type: "node", nodeName });
        //                 }
        //             }
        //         }
        //     }
        // ] : [];

        
        return (
            <Chart
                chartType="Sankey"
                data={chartData}
                options={{
                    colors: shadeDefault,
                    animation: {
                        duration: 1000,
                        easing: "out",
                    },
                }}
                // chartEvents={chartEvents}
                width="100%"
                height="100%"
            />
        )
    }

    return null;
}

export default InsightSankeyGraphView
